import { makeStyles } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';

export default makeStyles((theme: typeof muiTheme) => ({
    root: {
        width: 'fit-content' as const,
        backgroundColor: theme?.app?.applicationColors.failure || '#FA5252',
        borderRadius: '3px'
    },
    text: {
        padding: '.2rem .4rem',
        fontSize: '12px',
        color: theme?.app?.applicationColors.enumColors.black || '#FFFFFF'
    }
}));